var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M821 4994 c-178 -48 -329 -201 -376 -379 -13 -52 -15 -262 -15 -1735 0 -1848 -4 -1728 63 -1854 59 -112 190 -219 312 -256 22 -7 90 -15 150 -19 l110 -6 6 -115 c7 -132 27 -195 90 -290 70 -104 181 -182 305 -214 55 -14 213 -16 1416 -16 1493 0 1407 -4 1532 63 78 41 172 135 213 213 67 126 63 6 63 1854 0 1842 4 1729 -60 1849 -42 78 -100 143 -170 190 -95 63 -158 83 -290 90 l-115 6 -6 115 c-7 132 -27 195 -90 290 -70 103 -182 183 -304 215 -86 22 -2750 22 -2834 -1z m2847 -233 c70 -38 100 -69 140 -145 l27 -51 0 -1685 0 -1685 -27 -51 c-40 -76 -70 -107 -140 -145 l-63 -34 -1365 0 -1365 0 -63 34 c-70 38 -100 69 -140 145 l-27 51 0 1685 0 1685 23 45 c12 25 35 61 51 81 31 37 114 87 165 100 17 4 636 6 1376 6 l1345 -2 63 -34z m641 -641 c69 -37 99 -68 139 -144 l27 -51 0 -1685 0 -1685 -27 -51 c-40 -76 -70 -107 -140 -145 l-63 -34 -1365 0 -1365 0 -63 34 c-115 62 -163 145 -170 294 l-5 97 1160 0 c1277 0 1213 -3 1337 63 78 41 172 135 213 213 67 126 63 26 63 1657 l0 1480 98 -5 c87 -4 105 -9 161 -38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224 4141 c-44 -27 -60 -77 -41 -124 31 -72 -50 -67 1058 -67 984 0 997 0 1022 20 38 30 52 80 33 123 -29 71 34 67 -1058 67 -952 0 -984 -1 -1014 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224 3501 c-44 -27 -60 -77 -41 -124 31 -72 -50 -67 1058 -67 984 0 997 0 1022 20 38 30 52 80 33 123 -29 71 34 67 -1058 67 -952 0 -984 -1 -1014 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224 2861 c-44 -27 -60 -77 -41 -124 31 -72 -50 -67 1058 -67 984 0 997 0 1022 20 38 30 52 80 33 123 -29 71 34 67 -1058 67 -952 0 -984 -1 -1014 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224 2221 c-44 -27 -60 -77 -41 -124 30 -70 -2 -67 635 -67 l574 0 29 29 c48 49 34 142 -26 169 -19 9 -172 12 -583 12 -532 0 -558 -1 -588 -19z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.e8ae9bebc871560aa0c61d639e121809.svg";
export { ForwardRef as ReactComponent };